import PropTypes from 'prop-types';
import { className } from '../../../utils/GlobalCssProxy';
import Icon from '../icon/index';
import DropdownBasic from '../dropdown-basic';
import InteractiveElement from '../interactive-element';

const DropdownHeaderDocuments = ({
  items,
  isExternalSite,
  triggerExternalSiteModal,
  triggerModal
}) => {
  const onButtonClick = (url, urlList, label) => {

    //Moved all the behavior to the DropdownBasic component;
    // if (urlList && urlList.length > 0) {
    //   triggerModal(urlList);
    // } else if (label === 'Prospectus') {
    //   window.open(url, '_blank', 'location=yes,noopener,noreferrer');
    // } else if (isExternalSite) {
    //   triggerExternalSiteModal();
    // } else {
    //   window.open(url, '_blank', 'noopener,noreferrer');
    // }
  };
  return (
    <DropdownBasic items={items} triggerModal={triggerModal} triggerExternalSiteModal={triggerExternalSiteModal}>
      <DropdownBasic.Trigger>
        <Icon.Document style={{ fontSize: '28px' }} />
      </DropdownBasic.Trigger>
      <DropdownBasic.Item {...className('position-relative')}>
        {item => (
          <InteractiveElement
          as='a'
            {...className(
              'text-decoration-none',
              'stretched-link',
              'text-black'
            )}
            role="button"
            onClick={() => onButtonClick(item.url, item.urlList, item.label)}
          >
            {item.label}
          </InteractiveElement>
        )}
      </DropdownBasic.Item>
    </DropdownBasic>
  );
};

DropdownHeaderDocuments.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string
    })
  ),
  isExternalSite: PropTypes.bool,
  triggerExternalSiteModal: PropTypes.func,
  triggerModal: PropTypes.func
};

DropdownHeaderDocuments.defaultProps = {
  items: []
};

export default DropdownHeaderDocuments;
